// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__23ISs","actions":"GroupTable_actions__3AtCh","deleteModalFooter":"GroupTable_deleteModalFooter__1riuZ"};